import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconSupplierTransport = ({ id, color, width = 48, style, ...restProps }: IProps) => {
  const viewBoxWidth = 24;
  const viewBoxHeight = 24;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0251 19.4939H18.0234M16.0251 19.4939V21.1143C16.0251 21.1143 15.9437 21.8087 16.9835 21.8087C18.0234 21.8087 18.0234 21.1143 18.0234 21.1143V19.4939M16.0251 19.4939H7.91782M18.0234 19.4939H19.622C19.8313 19.5132 20.25 19.4129 20.25 18.8573V16.0794C20.1472 15.3798 19.693 14.1401 18.6514 13.6106M17.5666 13.3595H6.49048M17.5666 13.3595C17.4479 13.0199 17.2781 12.5354 17.0993 12.0284M17.5666 13.3595C17.9837 13.3595 18.3432 13.454 18.6514 13.6106M6.49048 13.3595L6.87797 12.0284M6.49048 13.3595C6.15106 13.4097 5.68551 13.5424 5.23443 13.7844M17.0993 12.0284C16.7906 11.1531 16.4552 10.2104 16.3106 9.82931C16.0822 9.22744 15.561 8.72975 14.2487 8.72975H9.40225C8.26038 8.72975 7.67042 9.46279 7.51817 9.82931L6.87797 12.0284M17.0993 12.0284H17.8521C18.1185 12.0412 18.6514 12.221 18.6514 12.8386V13.6106M6.87797 12.0284H5.91955C5.63408 12.0284 5.23443 12.422 5.23443 12.8386V13.7844M5.23443 13.7844C4.47152 14.1937 3.75 14.9157 3.75 16.0794V18.8573C3.78806 19.0695 4.01263 19.4939 4.6064 19.4939H5.91955M5.91955 19.4939V21.1143C5.91955 21.1143 5.83812 21.8087 6.87797 21.8087C7.91782 21.8087 7.91782 21.1143 7.91782 21.1143V19.4939M5.91955 19.4939H7.91782M13.6837 16.8899H10.2581M9.54618 4.02403C9.40513 4.02453 9.26738 4.07036 9.1503 4.15576C9.03323 4.24115 8.94207 4.36228 8.88835 4.50385C8.83458 4.36217 8.74333 4.24097 8.62613 4.15556C8.50892 4.07016 8.37103 4.02439 8.22987 4.02403C8.03397 4.04242 7.85173 4.14056 7.71972 4.29876C7.58772 4.45695 7.51571 4.66349 7.51817 4.87692C7.51817 5.81084 8.70564 6.57038 8.88835 6.57038C9.07106 6.57038 10.2585 5.81084 10.2585 4.87692C10.261 4.66338 10.1889 4.45675 10.0567 4.29854C9.92459 4.14032 9.74219 4.04225 9.54618 4.02403ZM14.8449 3.3479C14.645 3.3486 14.4499 3.41319 14.284 3.53352C14.1182 3.65385 13.989 3.82452 13.9129 4.02401C13.8368 3.82437 13.7075 3.65359 13.5415 3.53324C13.3754 3.4129 13.1801 3.34841 12.9801 3.3479C12.7026 3.37382 12.4444 3.51211 12.2574 3.73502C12.0704 3.95793 11.9684 4.24896 11.9718 4.54971C11.9718 5.86568 13.6541 6.93594 13.9129 6.93594C14.1718 6.93594 15.854 5.86568 15.854 4.54971C15.8575 4.24881 15.7553 3.95764 15.5681 3.73471C15.3809 3.51177 15.1225 3.37358 14.8449 3.3479ZM18.1375 16.0794C18.1375 16.5908 17.7286 17.0054 17.224 17.0054C16.7195 17.0054 16.3106 16.5908 16.3106 16.0794C16.3106 15.5681 16.7195 15.1535 17.224 15.1535C17.7286 15.1535 18.1375 15.5681 18.1375 16.0794ZM7.51817 16.0794C7.51817 16.5908 7.10918 17.0054 6.60467 17.0054C6.10016 17.0054 5.69118 16.5908 5.69118 16.0794C5.69118 15.5681 6.10016 15.1535 6.60467 15.1535C7.10918 15.1535 7.51817 15.5681 7.51817 16.0794Z"
        stroke={iconColor ?? '#546170'}
        strokeWidth="1.04762"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconSupplierTransport;
